import {Component} from '@angular/core';

import {AppAlertService, SubtitlesService} from "../../../core";

@Component({
    selector: 'general-policy-en',
    templateUrl: './general-policy-en.component.html',
    styleUrls: ['./general-policy-en.component.scss']
})
export class GeneralPolicyEnComponent {
    constructor(
        public appAlert: AppAlertService,
        public subtitles: SubtitlesService,
    ) {
    }
}
